module.exports = __webpack_public_path__ + "img/float2.2ab196aa.jpg";